import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

export const fetchClientRestriction = async (clientId) => {
    const res = await apiFetch(`${API_BASE}/clients/operator/${clientId}/restrictions`);
    if (!res.ok) throw new Error("Не вдалося завантажити обмеження клієнта");
    return await res.json();
};

export const fetchNetworkRestrictions = async () => {
    const res = await apiFetch(`${API_BASE}/clients/operator/restrictions`);
    if (!res.ok) throw new Error("Не вдалося завантажити список обмежень");
    return await res.json();
};

export const updateClientRestriction = async (clientId, payload) => {
    const res = await apiFetch(`${API_BASE}/clients/operator/${clientId}/restrictions`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        const detail = err?.detail;
        const msg = typeof detail === "string"
            ? detail
            : detail?.message || "Не вдалося оновити обмеження";
        throw new Error(msg);
    }
    return await res.json();
};

export const fetchOperatorComplaints = async (status = "open") => {
    const q = status ? `?status=${encodeURIComponent(status)}` : "";
    const res = await apiFetch(`${API_BASE}/clients/operator/complaints${q}`);
    if (!res.ok) throw new Error("Не вдалося завантажити скарги");
    return await res.json();
};

export const resolveOperatorComplaint = async (complaintId, payload) => {
    const res = await apiFetch(`${API_BASE}/clients/operator/complaints/${complaintId}/resolve`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        const detail = err?.detail;
        const msg = typeof detail === "string"
            ? detail
            : detail?.message || "Не вдалося опрацювати скаргу";
        throw new Error(msg);
    }
    return await res.json();
};
